import { defineComponent as _defineComponent } from 'vue'
import { useStoreRoot } from './stores/root';
import { storeToRefs } from 'pinia';
import SvgIcon from './SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlert',
  props: {
    status: {
        type: String,
        default: 'negative',
    },
},
  setup(__props) {

const props = __props;

const rootStore = useStoreRoot();
const { appErrors } = storeToRefs(rootStore);



const removeError = (err: any) => {
    appErrors.value.splice(appErrors.value.indexOf(err), 1);
};

return { __sfc: true,rootStore, appErrors, props, removeError, SvgIcon }
}

})